<template>
    <div class="user-item">
        <div class="user-item-image">
            <a :href="u_item.url">
                <img :src="u_item.img" />
            </a>
            <span v-if="status_flag" class="product-item-status" :class="u_item.status_class">{{ u_item.status_text }}</span>
        </div>
        <div class="user-item-info">
            <h2 class="title">
                <a :href="u_item.url">{{ u_item.name }}</a>
            </h2>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {
                u_item: this.item,
                status_flag: this.item.status_text ? true:false
            }
        },
    }
</script>

<style>
    .user-item {
        width:180px;
        height: 240px;
        border: 1px solid #E3E3E3;
        border-radius: 3px;
        margin-right: 15px;
        margin-bottom: 30px;
        float: left;
        background-color: #FEFEFE;
    }

    .user-item-image {
        height: 178px;
        width: 178px;
        position: relative;
        background-color: #E3E3E3;
    }

    @media (max-width: 768px) {
        .user-item {
            width: calc(50% - 4px);
            display: inline-block;
            margin-bottom: 15px;
            height: 230px;
        }

        .user-item-image {
            width: 100%;
            height: 160px;
        }

        .user-items-container .user-item:nth-child(even) {
            margin-right: 0;
        }

        .user-items-container .user-item:nth-child(odd) {
            margin-right: 8px;
        }

    }

    .user-item-image img {
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
    }

    .user-item-info {
        padding: 8px 8px 6px 8px;
    }

    .user-item-info h2 {
        font-size: 15px;
        line-height: 19px;
        height: 19px;
        margin-bottom: 0;
    }

    .user-item-info a, .user-item-info a:visited {
        color: #000; text-decoration: none;
    }

    .user-item-info a:hover {
        color: #000; text-decoration: underline;
    }

    .new-item-status {
        color: #fff;
        font-size: 13px;
        line-height: 20px;
        background-color: #F5485E;
        width: 44px;
        border-radius: 24px;
    }

    .sale-status-first {
        font-size: 14px;
        line-height: 24px;
        width: 23px;
        color: #fff;
        background-color: #F2C21D;
    }

    .sale-status-second {
        font-size: 14px;
        line-height: 24px;
        width: 23px;
        color: #fff;
        background-color: #D0D0D0;
    }

    .sale-status-third {
        font-size: 14px;
        line-height: 24px;
        width: 23px;
        color: #fff;
        background-color: #C09262;
    }

    .sale-status-other {
        font-size: 14px;
        line-height: 24px;
        width: 23px;
        color: #fff;
        background-color: #969696;
    }

    @media (max-width: 768px) {
        .sale-status-first, .sale-status-second, .sale-status-third, .sale-status-other
        {
            left: 0; top: 0;
        }
    }
</style>